module.exports = __webpack_public_path__ + "static/media/factslogo-v2.f04e01bf.svg";